<template>
      <AnnuaireDetails 
      :title="$t('annuaire_agences')" 
      :cover="'/images/hotels.webp'"
      :typeElement="'annuaire'"
      :icon="'/mapMarkers/hotel-icon.svg'"
      :url="urlAnnuaire"
      :parentUrl="'/agences/annuaire'"
       
      />
</template>
<script>
import AnnuaireDetails from "../partial/AnnuaireDetails.vue";
import { updateMetaTagsPage } from "../utils/filters";
export default{
    computed:{
       urlAnnuaire(){
        return `${process.env.VUE_APP_BACKEND_URL}allagencies`
       }
    },
    components:{
        AnnuaireDetails
    },
    data(){
    return{
      currentLanguage: this.$i18n.locale,
    }
  },
  methods:{
    updateMetaTags(language) {
    // Meta data object
const metaData = {
  // Russian (ru)
  "meta_title_ru": "Каталог туристических агентств в Тунисе - GabongoTravel",
  "meta_description_ru": "Полный каталог туристических агентств Туниса. Найдите лучшие агентства для организации отдыха, сравните услуги и цены.",
  "meta_keywords_ru": "каталог агентств Тунис, туристические агентства Туниса, лучшие агентства, бронирование туров, организация отдыха в Тунисе, услуги агентств, сравнение агентств",

  // French (fr)
  "meta_title_fr": "Annuaire des Agences de Voyage en Gabon - GabongoTravel",
  "meta_description_fr": "Découvrez notre annuaire complet des agences de voyage en Gabon. Trouvez les meilleures agences pour organiser vos séjours, comparez leurs services et tarifs.",
  "meta_keywords_fr": "annuaire agences Gabon, agences de voyage Gabon, meilleures agences, réservation voyages, organisation séjours Gabon, services agences, comparateur agences",

  // English (en)
  "meta_title_en": "Travel Agency Directory in Gabon - GabongoTravel",
  "meta_description_en": "Browse our complete directory of travel agencies in Gabon. Find the best agencies for your trips, compare services and prices.",
  "meta_keywords_en": "travel agency directory Gabon, Gabon travel agencies, best agencies, trip booking, Gabon tours, agency services, agency comparison",

  // Arabic (ar)
  "meta_title_ar": "دليل وكالات السفر في تونس - GabongoTravel",
  "meta_description_ar": "تصفح دليلنا الشامل لوكالات السفر في تونس. اكتشف أفضل الوكالات لتنظيم رحلاتك، قارن الخدمات والأسعار.",
  "meta_keywords_ar": "دليل وكالات السفر تونس, وكالات السفر تونس, أفضل الوكالات, حجز رحلات, تنظيم رحلات تونس, خدمات الوكالات, مقارنة الوكالات",

  // Chinese (zh)
  "meta_title_zh": "突尼斯旅行社目录 - GabongoTravel",
  "meta_description_zh": "浏览我们完整的突尼斯旅行社目录。找到最适合您旅程的旅行社，比较服务和价格。",
  "meta_keywords_zh": "突尼斯旅行社目录, 突尼斯旅行社, 最佳旅行社, 旅行预订, 突尼斯旅游, 旅行社服务, 旅行社比较",

  // Korean (ko)
  "meta_title_ko": "튀니지 여행사 디렉토리 - GabongoTravel",
  "meta_description_ko": "튀니지의 여행사 디렉토리를 확인하세요. 최고의 여행사를 찾아 여행을 계획하고 서비스와 가격을 비교하세요.",
  "meta_keywords_ko": "튀니지 여행사 디렉토리, 튀니지 여행사, 최고의 여행사, 여행 예약, 튀니지 투어, 여행사 서비스, 여행사 비교",

  // Japanese (ja)
  "meta_title_ja": "チュニジアの旅行代理店一覧 - GabongoTravel",
  "meta_description_ja": "チュニジアの旅行代理店一覧をご覧ください。最適な代理店を見つけ、サービスや料金を比較してください。",
  "meta_keywords_ja": "チュニジア 旅行代理店一覧, チュニジア 旅行代理店, 最高の代理店, 旅行予約, チュニジア ツアー, 代理店 サービス, 代理店比較"
};


   updateMetaTagsPage(language,metaData,'hotels/annuaire');
    },
    addCanonicalLink() {
  const currentUrl = window.location.href; // Get the current URL
  const currentLanguage = this.currentLanguage; // Fetch the current language
  let canonicalLink = document.querySelector("link[rel='canonical']");

  // Modify the URL based on the language
  const url = new URL(currentUrl);
  const pathSegments = url.pathname.split("/").filter(Boolean); // Remove empty segments

  if (currentLanguage === "ar" || currentLanguage === "en" || currentLanguage === "kor" || currentLanguage === "ru" || currentLanguage === 'zh' || currentLanguage === 'ja') {
    // Add language prefix if not already present
    if (pathSegments[0] !== currentLanguage) {
      pathSegments.unshift(currentLanguage);
    }
  } else if (currentLanguage === "fr" && pathSegments[0] === "ar" || pathSegments[0] === "en" || pathSegments[0] === "ru" || pathSegments[0] === 'ja' || pathSegments[0] === 'zh'  || currentLanguage === "kor") {
    // Remove language prefix if "fr" (default)
    pathSegments.shift();
  }

  url.pathname = "/" + pathSegments.join("/"); // Construct the new path
  const canonicalUrl = url.toString(); // Get the full URL as a string

  if (canonicalLink) {
    // Update the existing canonical link
    canonicalLink.setAttribute("href", canonicalUrl);
  } else {
    // Create a new canonical link
    canonicalLink = document.createElement("link");
    canonicalLink.setAttribute("rel", "canonical");
    canonicalLink.setAttribute("href", canonicalUrl);
    document.head.appendChild(canonicalLink);
  }
  },
  },
  watch:{
    "$i18n.locale"(newLocale) {
      this.currentLanguage = newLocale;
      this.updateMetaTags(newLocale);
      this.addCanonicalLink();

    },
  },
  mounted(){
    this.updateMetaTags(this.currentLanguage);
    this.addCanonicalLink();
  }
}
</script>